import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'bitbucket.metadataPanel.description.header',
    description: 'Header for the description section',
    defaultMessage: 'Description',
  },
});
